<template>
  <div class="portal-container">
    <!-- 顶部Banner区域 -->
    <el-container>
      <el-main class="banner-section">
        <el-carousel height="500px" arrow="never">
          <el-carousel-item v-for="item in banners" :key="item.id">
            <div
              class="banner-item"
              :style="{ backgroundImage: `url(${item.image})` }"
            >
              <div class="banner-content">
                <h1 class="banner-title">{{ item.title }}</h1>
                <div class="banner-name">{{ item.name }}</div>
                <p class="banner-description">
                  {{ item.description }}
                </p>
                <el-button
                  type="primary"
                  class="banner-button"
                  @click="handleLearnMore(item.link)"
                  >了解更多</el-button
                >
              </div>
            </div>
          </el-carousel-item>
        </el-carousel>
      </el-main>
    </el-container>

    <!-- 区域平台模块 -->
    <el-container class="section section-plat">
      <el-main>
        <div class="section-title">区域平台</div>
        <div class="section-title-en">RegionalHub</div>
        <el-row :gutter="20">
          <el-col
            :span="6"
            v-for="(platform, index) in platforms"
            :key="index"
          >
            <div
              class="platform-card"
              :body-style="{ padding: '0px' }"
              @click="handleToPlatformDetail(platform)"
            >
              <img :src="platform.icon" class="image" />
              <div class="card-content">
                <div class="content-title">
                  <span class="address">{{ platform.name }}</span>
<!--                  <span class="tip">算力平台</span>-->
                </div>
                <p class="content-description">
                  {{ platform.description }}
                </p>
              </div>
              <div class="card-footer">
                <el-button type="text" class="view-details-btn">
                  查看详情
<!--                  <i class="el-icon-arrow-right view-details-icon"></i>-->
                </el-button>
              </div>
            </div>
          </el-col>
        </el-row>
      </el-main>
    </el-container>

    <!-- 核心功能模块 -->
    <el-container class="section section-feature bg-gray">
      <el-main>
        <div class="section-title">核心功能</div>
        <div class="section-title-en">Core Functions</div>
        <div class="feature-card">
          <div v-for="(feature, index) in features" class="feature-li">
            <img class="feature-icon" :src="feature.icon" alt="" />
            <h3 class="feature-title">{{ feature.title }}</h3>
            <p class="feature-description">
              {{ feature.description }}
            </p>
          </div>
        </div>
      </el-main>
    </el-container>

    <!-- 新闻公告模块 -->
    <el-container class="section section-news">
      <el-main>
        <el-row :gutter="20">
          <el-col :span="12">
            <div class="news-section">
              <div class="top-ui">
                <div class="section-title-ui">平台新闻</div>
                <div class="section-header">
                  <div class="section-title-en-ui">Platform News</div>
                  <el-link type="primary" class="more-link" href="/news"
                    >更多<i class="el-icon-arrow-right"></i
                  ></el-link>
                </div>
              </div>
              <div
                v-for="(announcement, index) in newsList"
                :key="index"
                @click="handleToDetail(announcement)"
              >
                <el-card class="news-card" shadow="never">
                  <div class="announcement-title">
                    <h4>
                      {{ announcement.title }}
                    </h4>
                    <span class="date">{{ announcement.date }}</span>
                  </div>
                  <p class="announcement-content">
                    {{
                      announcement.content.replace(/<[^>]+>/g, "").slice(0, 200)
                    }}
                  </p>
                </el-card>
                <div
                  style="height: 1px; background-color: #ebebeb; margin: 20px 0"
                ></div>
              </div>
            </div>
          </el-col>
          <el-col :span="12">
            <div class="announcement-section">
              <div class="top-ui">
                <div class="section-title-ui">重要公告</div>
                <div class="section-header">
                  <div class="section-title-en-ui">Important Announcements</div>
                  <el-link
                    type="primary"
                    class="more-link"
                    @click="handleToAnnouncementMores"
                    >更多<i class="el-icon-arrow-right"></i
                  ></el-link>
                </div>
              </div>

              <div v-for="(announcement, index) in announcements" :key="index">
                <el-card class="announcement-card" shadow="never">
                  <div class="announcement-title">
                    <h4>
                      <img
                        class="announcement-icon"
                        src="../assets/img/gonggao.png"
                        alt=""
                      />
                      {{ announcement.title }}
                    </h4>
                    <span class="date">{{ announcement.date }}</span>
                  </div>
                  <p class="announcement-content">
                    {{ announcement.content }}
                  </p>
                </el-card>
                <div
                  style="height: 1px; background-color: #ebebeb; margin: 20px 0"
                ></div>
              </div>
            </div>
          </el-col>
        </el-row>
      </el-main>
    </el-container>
  </div>
</template>

<script>
import { newsPage, announcementPage } from "@/api/index";
export default {
  name: "Portal",
  methods: {
    handleLearnMore() {
      this.$router.push({
        path: "/platform",
      });
    },
    // 跳转至新闻详情页面
    handleToDetail(item) {
      this.$router.push(`/news/detail/${item.id}`);
    },
    // 跳转新闻页面
    handleToNewMores() {
      this.$router.push({
        path: "/news",
        query: {
          tab: "news",
        },
      });
    },
    // 跳转公告页面
    handleToAnnouncementMores() {
      this.$router.push({
        path: "/news",
        query: {
          tab: "announcement",
        },
      });
    },
    // 跳转至地区平台详情页面
    handleToPlatformDetail(platform) {
      if (platform.areaType === 1) {
        this.$router.push({
          path: "/local/jsdetail",
          query: {
            areaType: platform.areaType,
          },
        });
      } else {
        this.$router.push({
          path: "/local/detail",
          query: {
            areaType: platform.areaType,
          },
        });
      }
    },
    // 获取新闻列表
    async getNewsList() {
      try {
        const res = await newsPage({ current: 1, size: 3 });
        if (res.data) {
          this.newsList = res.data.records;
        }
      } catch (error) {
        console.error("获取新闻列表失败:", error);
      }
    },
    // 获取公告列表
    async getAnnouncementList() {
      try {
        const res = await announcementPage({ current: 1, size: 3 });
        if (res.data) {
          this.announcements = res.data.records;
        }
      } catch (error) {
        console.error("获取公告列表失败:", error);
      }
    },
  },
  data() {
    return {
      banners: [
        {
          id: 1,
          title: "全国一体化算力网国家枢纽节点（长三角）",
          name: "算力公共服务平台",
          description:
            "打造算力新生态，助力长三角一体化发展。通过先进的技术架构和创新的解决方案，提供高效、安全、可靠的算力服务",
          image: require("../assets/bg/banner_bg.png"),
          link: "/platform-detail",
        },
      ],
      platforms: [
        {
          name: "上海",
          description: "长三角核心算力中心，汇聚全球领先计算资源，引领科技创新",
          icon: require("../assets/img/image.png"),
          areaType: 2,
        },
        {
          name: "江苏",
          description: "产业智能化升级基地，打造数字经济新引擎，服务制造业转型",
          icon: require("../assets/img/image1.png"),
          areaType: 1,
        },
        {
          name: "浙江",
          description: "数字经济示范区，推动智慧城市建设，引领数字化变革",
          icon: require("../assets/img/image2.png"),
          areaType: 4,
        },
        {
          name: "安徽",
          description:
            "安徽省重点算力基地，集成多元算力资源，支持区域数字经济发展",
          icon: require("../assets/img/image3.png"),
          areaType: 3,
        },
      ],
      features: [
        {
          icon: require("../assets/img/tongyirenzheng2.png"),
          title: "统一认证",
          description:
            "完善的用户权限管理系统，确保资源使用安全可控，提供个性化的服务体验",
        },
        {
          icon: require("../assets//img/suanlidiaodu2.png"),
          title: "算力调度",
          description:
            "智能化算力资源调度系统，实现算力资源的高效分配和优化利用，支持多样化计算需求",
        },
        {
          icon: require("../assets/img/jiaoyitongbu2.png"),
          title: "交易同步",
          description:
            "实时交易数据同步引擎，支持跨平台智能合约自动执行，保障多方交易原子性与一致性",
        },
      ],
      newsList: [],
      announcements: [],
    };
  },
  created() {
    this.getNewsList();
    this.getAnnouncementList();
  },
};
</script>

<style scoped lang="scss">
.portal-container {
  min-height: 100vh;
  min-width: 1400px;

  .section-plat {
    .platform-card {
      cursor: pointer;

      .image {
        width: 100%;
        height: 300px;
        display: block;
      }

      .card-content {
        background: #f3f5f5;
        padding: 30px;
        transition: all 0.3s;
        text-align: center;


        .content-title {
          .address {
            font-size: 28px;
            font-weight: bold;
            color: #333333;
            padding-right: 10px;
          }
          .tip {
            font-size: 16px;
            color: #656565;
          }
        }
        .content-description {
          font-family: MicrosoftYaHei;
          font-size: 16px;
          color: #656565;
          line-height: 24px;
          margin-bottom: 0;
        }
      }

      .card-footer {
        transition: all 0.3s;
        height: 58px;
        display: flex;
        align-items: center;
        justify-content: center;
        background: linear-gradient(135deg, #f8f9fa 0%, #ffffff 100%);  // 浅色渐变背景
        border-top: 1px solid #eef2f7;  // 只保留顶部边框，使用更柔和的颜色
        padding: 0 30px;
        box-shadow: 0 -1px 3px rgba(0, 0, 0, 0.02);  // 添加轻微的阴影效果

        .view-details-btn {
          border: 1px solid #057bf3;
          background: transparent;
          color: #057bf3;
          font-size: 14px;
          padding: 8px 16px;
          border-radius: 20px;
          transition: all 0.3s ease;
          display: flex;
          align-items: center;
          font-weight: 500;

          &:hover {
            color: #057bf3;
            background-color: #057bf3;
            transform: translateY(-1px);
            box-shadow: 0 4px 8px rgba(5, 123, 243, 0.3);

            .view-details-icon {
              transform: translateX(2px);
            }
          }
          &:active {
            transform: translateY(0);
          }
        }

        .view-details-icon {
          transition: transform 0.3s ease;
          margin-left: 4px;
        }
      }
    }

    .platform-card:hover {
      .card-content {
        background: #067bf3;
        .content-title {
          .address {
            color: #fff;
          }
          .tip {
            color: #fff;
          }
        }
        .content-description {
          color: #fff;
        }
      }
      .card-footer {
        background: linear-gradient(135deg, #067bf3 0%, #1a8cff 100%);  // 渐变蓝色背景
        border-top: 1px solid #2990f9;

        .view-details-btn {
          color: #fff;
          border-color: #fff;
          background-color: transparent;

          &:hover {
            color: #067bf3;
            background-color: #fff;

            .view-details-icon {
              color: #067bf3;
            }
          }
        }
      }
    }
  }

  .section-feature {
    .feature-card {
      box-shadow: 0 0.125rem 0.75rem 0 rgba(0, 0, 0, 0.1);
      border-radius: 20px 20px 20px 20px;
      display: flex;
      flex-direction: row;
      justify-content: space-around;
      height: 385px;
      align-items: center;
      background-color: #fff;
      padding: 0;

      .feature-li {
        width: 33.33%;
        position: relative;
        padding: 0 60px;

        .feature-icon {
          width: 120px;
          height: 120px;
          margin-bottom: 20px;
          border-radius: 50%;
          /* box-shadow: 0 10px 20px rgba(226, 240, 254, 0.9),
                        0 6px 12px rgba(226, 240, 254, 0.7),
                        0 4px 8px rgba(226, 240, 254, 0.5),
                        0 2px 4px rgba(226, 240, 254, 0.3); */
        }

        .feature-title {
          margin-top: 0;
          font-size: 28px;
        }

        .feature-description {
          font-size: 16px;
          color: #656565;
          line-height: 24px;
          margin-bottom: 0;
        }
      }

      .feature-li:not(:first-child)::before {
        content: "";
        position: absolute;
        left: 0;
        top: 50%;
        transform: translateY(-50%);
        width: 1px;
        height: 100%;
        background: linear-gradient(to top, #ffffff, #bdd8fd, #ffffff);
      }
    }
  }

  .section-news {
    background: linear-gradient(to bottom, #fefefe, #fff);
  }
}

.section {
  padding: 40px 241px;
}

.section-title {
  text-align: center;
  font-size: 36px;
  color: #333333;
}

.section-title-en {
  text-align: center;
  font-size: 20px;
  color: #cdcdcd;
  font-weight: bold;
  margin-bottom: 20px;
}

.bg-gray {
  background: linear-gradient(to bottom, #f2f2f2, #fefefe);
}

.bg-dark {
  background-color: #f4f4f4;
}

/* Banner样式 */
.banner-section {
  padding: 0;
  position: relative;
  height: 650px;

  ::v-deep .el-carousel {
    height: 100% !important;
    .el-carousel__container {
      height: 100% !important;
    }

    .el-carousel__indicators {
      display: none !important;
    }
  }
}

.banner-item {
  height: 100%;
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;

  &::before {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: linear-gradient(
      to bottom,
      rgba(0, 0, 0, 0.4),
      rgba(0, 0, 0, 0.1)
    );
  }

  .banner-content {
    position: relative;
    z-index: 1;
    color: #fff;
    padding: 0 241px;
    text-align: center; // 添加居中对齐

    .banner-title {
      font-size: 60px;
      font-weight: bold;
      margin-bottom: 20px;
    }

    .banner-name {
      font-size: 50px;
      font-weight: bold;
      margin-bottom: 20px;
      color: #fff;
    }

    .banner-description {
      font-size: 16px;
      margin-bottom: 60px;
      opacity: 0.9;
    }

    .banner-button {
      padding: 15px 30px;
      font-size: 14px;
      border-radius: 40px;
      transition: all 0.3s ease;
      background: #057bf3;
      &:hover {
        transform: translateY(-2px);
        box-shadow: 0 4px 12px rgba(6, 123, 243, 0.3);
      }
    }
  }
}

/* 平台卡片样式 */
.platform-card {
  margin-bottom: 20px;
  transition: all 0.3s;
}

.platform-card:hover {
  transform: translateY(-5px);
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
}

.platform-card .image {
  width: 100%;
  display: block;
}

//.card-content {
//  padding: 14px;
//}

/* 功能卡片样式 */
.feature-card {
  text-align: center;
  padding: 20px 0;
  margin-bottom: 20px;
}

.feature-card i {
  font-size: 40px;
  color: #409eff;
  margin-bottom: 20px;
}

/* 新闻公告样式 */
.news-section,
.announcement-section {
  .top-ui {
    border-bottom: 1px solid rgba(153, 153, 153, 0.5);
    margin-bottom: 24px;
  }
  .section-title-ui {
    font-size: 36px;
    color: #333333;
  }
  .section-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 20px;

    .section-title-en-ui {
      font-size: 20px;
      color: #cdcdcd;
    }

    h3 {
      margin: 0;
      font-size: 20px;
      color: #333;
    }

    .more-link {
      font-size: 14px;
      color: #999999;
      i {
        margin-left: 5px;
      }
    }

    .more-link:hover {
      color: #409eff;
    }
  }

  .announcement-card {
    background: #f3f3f3;
    height: 130px;
    cursor: pointer;

    ::v-deep .el-card__body {
      padding: 20px 26px;
    }

    .announcement-title {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-bottom: 12px;

      h4 {
        margin: 0;
        font-size: 20px;
        color: #333;
        flex: 1;
        font-weight: normal;
        display: flex;
        align-items: center;

        .announcement-icon {
          height: 19px;
          margin-right: 4px;
        }
      }

      .date {
        font-weight: bold;
        font-size: 16px;
        color: #858484;
        margin-left: 10px;
      }
    }

    .announcement-content {
      margin: 0;
      line-height: 1.5;
      font-size: 16px;
      color: #858585;
      /* white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis; */
      display: -webkit-box; /* 必须结合 -webkit-line-clamp 使用 */
      -webkit-box-orient: vertical; /* 设置盒子的排列方向为垂直 */
      -webkit-line-clamp: 2; /* 显示的行数 */
      overflow: hidden;
      line-height: 30px;
    }
  }

  .news-card {
    height: 130px;
    cursor: pointer;
    border: 1px solid #fff;

    ::v-deep .el-card__body {
      padding: 26px 0;
    }

    .announcement-title {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-bottom: 22px;

      h4 {
        margin: 0;
        font-size: 20px;
        color: #333;
        flex: 1;
        font-weight: normal;
        display: flex;
        align-items: center;

        .announcement-icon {
          height: 19px;
          margin-right: 4px;
        }
      }

      .date {
        font-weight: bold;
        font-size: 16px;
        color: #858484;
        margin-left: 10px;
      }
    }

    .announcement-content {
      margin: 0;
      line-height: 1.5;
      font-size: 16px;
      color: #858585;
      display: -webkit-box; /* 必须结合 -webkit-line-clamp 使用 */
      -webkit-box-orient: vertical; /* 设置盒子的排列方向为垂直 */
      -webkit-line-clamp: 2; /* 显示的行数 */
      overflow: hidden;
      line-height: 30px;
    }
  }

  .announcement-card:hover {
    /* background: #ecf5ff; */
  }

  .news-card:hover {
    .announcement-title {
      h4 {
        color: #067bf3;
      }
    }
  }
}
</style>
